import { render, staticRenderFns } from "./AddEditDepartment.vue?vue&type=template&id=3b837119&"
import script from "./AddEditDepartment.vue?vue&type=script&lang=ts&"
export * from "./AddEditDepartment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports